import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=0dd1a19f"
import script from "./UserGroupForm.vue?vue&type=script&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&lang=js"
import style0 from "./UserGroupForm.vue?vue&type=style&index=0&id=0dd1a19f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports